export const extrapolateSeries = (series, date) => {
    let zones;
    const samples = series.samples.map((s) => ([new Date(s.date).getTime(), s.value]));
    if (samples.length > 0) {
        if (date - samples[samples.length - 1][0] > 1000) {
            zones = [
                {value: samples[samples.length - 1][0]},
                {dashStyle: 'ShortDot'},
            ];
            samples.push([date.getTime(), samples[samples.length - 1][1]]);
        }
    }
    return {samples, zones};
};

export const isHistoryLoaded = (...args) => {
    return !args.some((x) => !x || x.loading || x.error);
};
